const env = process.env.REACT_APP_ENV;

module.exports = require(`./config.${env}.js`);
